<template>
  <a-dropdown autoAdjustOverflow placement="bottomRight">
    <template #overlay>
      <a-menu>
        <a-menu-item-group>
          <a-menu-item key="3" @click="showModal">
            <template #icon>
              <v-icon icon="SwapOutlined" :size="false"/>
            </template>
            切换项目
          </a-menu-item>
          <a-menu-item key="4" @click="quitSystem">
            <template #icon>
              <v-icon icon="LogoutOutlined" :size="false"/>
            </template>
            退出登录
          </a-menu-item>
        </a-menu-item-group>
      </a-menu>
    </template>
    <div class="userInfo">
      <a-avatar :size="28" :src="`${config.logo}`"/>
      <span class="nickname">{{ nickname }}</span>
      <span class="version">{{ role.name }}</span>
    </div>
  </a-dropdown>
  <a-modal
      v-model:visible="visible"
      title="切换项目"
      :footer="null"
      width="800px"
  >
    <div style="width: 100%;display: flex;flex-direction: column;">
      <a-space direction="vertical">
        <a-input allow-clear v-model:value="searchCityName" style="width: 100%;" size="large" @keydown="handleKey"
                 placeholder="请输入项目名称或项目ID或项目类型或城市">
          <template #addonBefore>
            <a-select v-model:value="cityId" style="width: 90px" @change="changeCity">
              <a-select-option value="0">全部</a-select-option>
              <a-select-option :value="item.cityId" v-for="(item,index) in userInfo.cityList" :key="index">
                {{ item.cityName }}
              </a-select-option>
            </a-select>
          </template>
          <template #addonAfter>
            <search-outlined @click="changeCity"/>
          </template>
        </a-input>
      </a-space>
      <a-table style="margin-top: 15px;" :columns="dataColumn" :data-source="dataSource" :pagination="false"
               :customRow="changeProject"
               :scroll="{ y: 400 }">
        <template #bodyCell="{ column,record }">
          <template v-if="column.key === 'goHome'">
            <a-tooltip title="查看地址" color="#2db7f5">
              <a-button type="primary" shape="circle" :size="size" @click.stop="navigation(record)">
                <template #icon>
                  <HomeOutlined/>
                </template>
              </a-button>
            </a-tooltip>
          </template>
        </template>
      </a-table>
    </div>

  </a-modal>

</template>

<script setup>
/*
* 顶部导航用户信息组件
* */
import user from "@/stores/user";
import devStore from "@/stores/devStore";
import {storeToRefs} from 'pinia';
import quitSystem from "@/service/quit-system";
import config from "@/config";
import {ref, createVNode} from "vue";
import {SearchOutlined, HomeOutlined, ExclamationCircleOutlined} from "@ant-design/icons-vue"
import {Modal} from 'ant-design-vue';
import api from "@/service/api";
import {axiosPost} from "@/layouts/admin-sidebar/requstDev";
import {serialize} from "@/utils/index"
import load from "@/common/load";
import {router} from "@/router";
let userInfo = user();
let dev = devStore();
let size = ref('small');
let {
  nickname,
  role
} = storeToRefs(userInfo)
let visible = ref(false);
const showModal = () => {
  visible.value = true;
};
let cityId = ref("0");
let searchCityName = ref("");
// 表格数据源
let dataSource = ref([]);
dataSource.value = [...userInfo.buildList];
// 键盘事件
let handleKey = function (e) {
  // 获取按下的键的ASCII码
  const keyCode = e.keyCode || e.which;
  // 检查是否按下了特定的键，例如回车键
  if (keyCode === 13) {
    changeCity()
  }
}
import mqttTool from "@/utils/mqtt/index"
import singleDev from "@/stores/singleDev";
// 切换项目
let changeProject = function (record) {
  return {
    onclick: () => {
      Modal.confirm({
        title: '是否确认切换项目?',
        icon: createVNode(ExclamationCircleOutlined),
        centered: true,
        onOk: async () => {
          let {buildName, buildId, systemVersion, cityName} = record;
          userInfo.buildName = buildName;
          userInfo.buildId = buildId;
          userInfo.systemVersion = systemVersion;
          userInfo.cityName = cityName;
          visible.value = false;
          await dev.reset();
          dev.getDevStoreList();
          // devStore().$reset(); //重置用户数据的状态管理器
          devStore().initDevStroe()
          singleDev().$reset();
          dev.mode = "information";
          if(mqttTool.client.connected){
            if(mqttTool.subscribeSuccess){
              mqttTool.doUnSubscribe()
            }
          }
          router.replace("/"); //跳转首页
        },
        onCancel() {
        },
      });

    }
  }
}
// 表头数据源
let dataColumn = [
  {title: '项目Id', dataIndex: 'buildId', key: 'buildId', align: 'center'},
  {title: '项目名称', dataIndex: 'buildName', key: 'buildName', align: 'center'},
  {title: '项目所属城市', dataIndex: 'cityName', key: 'cityName', align: 'center'},
  {title: '系统版本', dataIndex: 'systemVersion', key: 'systemVersion', align: 'center'},
  {title: '操作', dataIndex: 'goHome', key: 'goHome', align: 'center'},
]
// 切换城市
let changeCity = function () {
  let firledList = userInfo.buildList.filter(item => {
    return (item.cityId === cityId.value || cityId.value === '0') &&
        (item.cityName.includes(searchCityName.value) || searchCityName.value === '' || item.buildId.includes(searchCityName.value) || item.buildName.includes(searchCityName.value))
  })
  dataSource.value = firledList
}
// 导航
let navigation =async function (record) {
  try {
    load.loading("加载项目坐标...")
    let result = await axiosPost(api.getProjectInfo,serialize({
      buildingID:record.buildId
    }));
    load.loaded()
    if(result.result === '1'){
        let data = result.response[0];
        window.open(`https://www.beefindtech.com/devplatform/confPlateMap/index.html?coor=${data.position[0]},${data.position[1]}&buildName=${data.buildingName}&cityId=${data.cityID.substr(2,6)}`)
    }else {
      load.error("加载项目坐标出错...")
    }
  }catch (e) {
    load.error("加载项目坐标出错...")
  }
}

</script>

<style lang="scss" scoped>
.userInfo {
  height: 60px;
  display: flex;
  align-items: center;
  margin-right: 36px;
  cursor: pointer;
  position: relative;

  .nickname {
    margin: 0 12px;
    font-size: 14px;
    white-space: nowrap;
    color: $text;
  }


  .version {
    display: inline;
    padding: 0 3px;
    border: 1px solid $border-2;

    line-height: normal;
    white-space: nowrap;
    font-size: 12px;
    color: $sub-sub-text;
    border-radius: 4px;
  }

}


:deep(.ant-dropdown-menu-item) {
  margin: $margin-menu 0;
}


.menu-title {
  display: flex;
  flex-direction: column;
  margin: 0 $margin-menu;
  min-width: 180px;

  .menu-title-up {
    font-weight: bold;
    color: $sub-text;
  }

  .menu-title-bottom {
    margin-top: $margin-menu;
    font-size: $font-size-sm-sm;
  }

  .red {
    font-weight: bold;
    color: red;
  }
}

</style>
